import documentModelMixin from "@/mixins/documentModel";
import customProperties from "@/services/word/customPropertiesService";
import contentControls from "@/services/word/contentControlsService";
import contentBlocks from "@/services/sharedo/contentBlocksService";
import { CONTENT_BLOCK, HTML_CONTENT_BLOCK } from "@/constants/contentControlTypes";

const displayRefreshConfirmModal = function () {
    const vm = this;

    vm.showRefreshModal = false;
    vm.showRefreshConfirmModal = true;
};

const cancelRefreshContentBlocks = function () {
    const vm = this;

    vm.showRefreshModal = false;
    vm.showRefreshConfirmModal = false;
    vm.showRefreshAllModal = false;
    vm.currentBlock = null;
};

const displayRefreshAllModal = function () {
    const vm = this;

    vm.showRefreshAllModal = true;
};

const refreshContentBlocks = async function (all = false) {
    this.logDebug("Refreshing content block(s).", { all });

    const vm = this;
    const blocksToUpdate = [];

    try {
        if (all) {
            const sharedoId = await customProperties.get("SharedoActivityId");

            for (let i = 0; i < vm.contentBlocks.length; i++) {
                const contentBlock = vm.contentBlocks[i];
                const result = await contentBlocks.loadOne(
                    contentBlock.systemName,
                    sharedoId
                );

                blocksToUpdate.push({
                    ...result,
                    title: contentBlock.title,
                    versionNumber: contentBlock.versionNumber,
                    versionDate: contentBlock.versionDate,
                    availableForDocumentAuthors: contentBlock.availableForDocumentAuthors,
                    availableForTemplateAuthors: contentBlock.availableForTemplateAuthors,
                });
            }
        } else {
            blocksToUpdate.push(vm.currentBlock);
        }

        this.logInfo("Retrieved content for blocks to be updated.", { blocksToUpdate });

        for (let i = 0; i < blocksToUpdate.length; i++) {
            const contentBlock = blocksToUpdate[i];
            const contentControlIds = vm.documentModel
                .findContentControlBySystemName(contentBlock.systemName)
                .filter((control) => control.type === HTML_CONTENT_BLOCK)
                .map((control) => control.id);

            for (let i = 0; i < contentControlIds.length; i++) {
                const id = contentControlIds[i];
                await contentControls.replaceHtmlContent(id, contentBlock.htmlContent);
                this.logDebug("Updated content control with new content.", { id, htmlContent: contentBlock.htmlContent });

                const model = vm.documentModel;
                const contentControlModel = model.findContentControl(id);

                contentControlModel.version = {
                    number: contentBlock.versionNumber,
                    date: contentBlock.versionDate,
                };

                await vm.saveDocumentModel(model);
                this.logDebug("Document model saved.", model);
            }
        }

        vm.showRefreshConfirmModal = false;
        vm.showRefreshAllModal = false;
        vm.currentBlock = null;
    } catch (error) {
        this.logError("Error refreshing content blocks.", { blocksToUpdate, error });
        throw error;
    }
}

const mixin = {
    mixins: [documentModelMixin],
    data: function () {
        return {
            currentBlock: null,
            showRefreshModal: false,
            showRefreshAllModal: false,
            showRefreshConfirmModal: false,
        }
    },
    computed: {
        currentBlocks: function () {
            if (this.documentModel) {
                return [
                    ...this.documentModel.findContentControlByType(HTML_CONTENT_BLOCK),
                ];
            }

            return [];
        },
    },
    methods: {
        displayRefreshConfirmModal,
        displayRefreshAllModal,
        refreshContentBlocks,
        cancelRefreshContentBlocks
    }
}

export default mixin;